import React from "react";
import "./componentsStyle.scss";

export const PagesBanner = ({ title, description, image }) => {
  return (
    <section className="hero-banner">
      <img src={image} alt="Banner" className="hero-image" />

      <div className="hero-overlay" />

      <div className="hero-content">
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
    </section>
  );
};
